export class PnlReportReadModel
{
    CurrencyLabel: string;
    Columns: PnlReportColumnReadModel[];
    Revenues: PnlReportRowReadModel;
    Cogs: PnlReportRowReadModel;
    Opex: PnlReportRowReadModel;
    GrossMargin: PnlReportRowReadModel;
    EBITA: PnlReportRowReadModel;
    OtherExpenses: PnlReportRowReadModel;
    AdjustedEBITA: PnlReportRowReadModel;
    Resources: PnlReportRowReadModel;
}

export class PnlReportColumnReadModel
{
    Label: string;
}

export class PnlReportRowReadModel
{
    Id: string;
    Label: string;
    Type: string;
    Values: string[];
    GrowthPercentages: string[];
    PercentageOfSales: string[];
    Subtotals: PnlReportRowReadModel[];
    Accounts: PnlReportRowReadModel[];
    IsCollapsable: boolean;
    IsCollapsed: boolean;

    Cagr3yr: string;
    Cagr5yr: string;
}
export class PnlTemplateReadModel
{
    Id: string;
    Name: string;
    IsDefault: boolean;
    StartMonth: number;
    StartYear: number;
    Columns: string;
}

export class CorporatePnlTemplatesListReadModel
{
    Templates: CorporatePnlTemplateReadModel[];
}

export class CorporatePnlTemplateReadModel
{
    Id: string;
    Name: string;
    IsDefault: boolean;
    StartMonth: number;
    StartYear: number;
    Columns: string;
}

export class PnlsPageReadModel
{
    Defaults: CorporatePnlTemplateReadModel[];
    Corporate: CorporatePnlTemplateReadModel[];
}
